import { c as _c } from "react/compiler-runtime";
import { TourCardPropertiesType } from "@website/accommodation-ui/tour-card";
import { TourCardRating } from "@website/accommodation-ui/tour-card/tour-card-hotel-rating";
import { MaterialIcon } from "@website/icons/material";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { FC } from "react";
export const TourCardHotel: FC<TourCardPropertiesType> = properties => {
  const $ = _c(19);
  const {
    searchId,
    hotel,
    isDomestic
  } = properties;
  let t0;
  if ($[0] !== hotel) {
    t0 = hotel || {};
    $[0] = hotel;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    stars,
    name,
    rating,
    reviewCount
  } = t0;
  const router = useRouter();
  let t1;
  if ($[2] !== hotel?.id || $[3] !== isDomestic || $[4] !== router || $[5] !== searchId) {
    t1 = () => {
      router.push({
        pathname: "/[origin]/[dest]/[id]",
        query: {
          ...router.query,
          id: searchId,
          hotelId: hotel?.id,
          isDomestic
        }
      });
    };
    $[2] = hotel?.id;
    $[3] = isDomestic;
    $[4] = router;
    $[5] = searchId;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  let t2;
  if ($[7] !== name) {
    t2 = <h2 className="line-clamp-1">{name}</h2>;
    $[7] = name;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className="flex items-center justify-between"><button className="border-0 bg-transparent p-0 text-start" type="button" onClick={t1}>{t2}</button></div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== rating || $[13] !== reviewCount || $[14] !== stars) {
    t4 = stars || rating ? <div className="mt-2 flex items-center justify-between"><div>{stars && stars > 0 ? <div className="text-caption text-on-surface-high-emphasis flex items-center">{Array.from({
            length: stars
          }, _temp)}<div className="ms-1">{numberConvert(stars, {
              locale: "fa"
            })} ستاره</div></div> : null}</div><TourCardRating rating={rating} reviewCount={reviewCount} /></div> : null;
    $[12] = rating;
    $[13] = reviewCount;
    $[14] = stars;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <div className="px-4 pt-3">{t3}{t4}</div>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
};
function _temp(_, index) {
  return <MaterialIcon key={`TourCardHotel-${index}`} name="star" />;
}